export default "__VITE_ASSET__CNF5ef_A__"